const initialState = {
  data: [],
  dataview:[],
  adddata:[],
  imgdata:[],
  editdat:[],
  deletedata:[],
};

const ddocumentReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'FETCH_DATA_SUCCESS':
      return { ...state, data: action.payload };
      case 'FETCH_VIEW_DATA_SUCCESS':
      return{ ...state, dataview: action.payload }
      case 'FETCH_ADD_DATA_SUCCESS':
      return{ ...state, adddata: action.payload }
      case 'FETCH_ADD_DATA_SUCCESS_file':
        return{ ...state, imgdata:action.payload}
      case 'FETCH_EDIT_DATA_SUCCESS_file':
        return{ ...state,editdat:action.payload}
        case 'fetch_delete_data_success':
          return {... state, deletedata:action.payload};
    default:
      return state;
  }
};

export default ddocumentReducer;